"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _css = require("@emotion/css");
var _checkCircleFilled = _interopRequireDefault(require("@amzn/meridian-tokens/base/icon/check-circle-filled"));
var _checkKnockout = _interopRequireDefault(require("@amzn/meridian-tokens/base/icon/check-knockout"));
var _error = _interopRequireDefault(require("@amzn/meridian-tokens/base/icon/error"));
var _errorFilled = _interopRequireDefault(require("@amzn/meridian-tokens/base/icon/error-filled"));
var _errorKnockout = _interopRequireDefault(require("@amzn/meridian-tokens/base/icon/error-knockout"));
var _alert = _interopRequireDefault(require("@amzn/meridian-tokens/base/icon/alert"));
var _alertFilled = _interopRequireDefault(require("@amzn/meridian-tokens/base/icon/alert-filled"));
var _alertKnockout = _interopRequireDefault(require("@amzn/meridian-tokens/base/icon/alert-knockout"));
var _elevation = require("@amzn/meridian-tokens/base/elevation");
var _progressTrackerContext = _interopRequireDefault(require("./progress-tracker-context"));
var _icon = _interopRequireDefault(require("../icon"));
var _functional = require("./../_utils/functional");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/**
 * Circle
 */

var circleStyles = (0, _functional.memoizeByKeys)(function (_ref) {
  var diameter = _ref.diameter,
    borderRadius = _ref.borderRadius,
    borderWidth = _ref.borderWidth,
    borderColor = _ref.borderColor,
    backgroundColor = _ref.backgroundColor,
    foregroundColor = _ref.foregroundColor;
  return (0, _css.css)({
    boxSizing: "border-box",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: diameter,
    height: diameter,
    borderRadius: borderRadius,
    border: "".concat(borderWidth, "px solid ").concat(borderColor),
    backgroundColor: backgroundColor,
    color: foregroundColor,
    zIndex: _elevation.elevationForeground
  });
}, ["diameter", "borderRadius", "borderWidth", "borderColor", "backgroundColor", "foregroundColor"]);
function Circle(props) {
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: circleStyles(props)
  }, props.children);
}
Circle.propTypes = process.env.NODE_ENV !== "production" ? {
  backgroundColor: _propTypes["default"].string,
  borderColor: _propTypes["default"].string,
  borderRadius: _propTypes["default"].number,
  borderWidth: _propTypes["default"].number,
  children: _propTypes["default"].node,
  diameter: _propTypes["default"].number,
  foregroundColor: _propTypes["default"].string
} : {};
var stepStyles = (0, _functional.memoizeByKeys)(function (_ref2) {
  var diameter = _ref2.diameter,
    foregroundColor = _ref2.foregroundColor;
  return (0, _css.css)({
    boxSizing: "border-box",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: diameter,
    height: diameter,
    color: foregroundColor,
    zIndex: _elevation.elevationForeground
  });
}, ["diameter", "foregroundColor"]);

/**
 * Milestone
 */

function Milestone(props) {
  var _useContext = (0, _react.useContext)(_progressTrackerContext["default"]),
    t = _useContext.t;
  var colorState = [props.neutral ? "neutral" : "theme", props.type, props.alert].filter(Boolean);
  var diameter = t("milestoneDiameter", props.size);
  var stepColor = t("milestoneForegroundColor", colorState);
  var stepShapeProps = {
    diameter: diameter,
    backgroundColor: stepColor,
    borderColor: t("milestoneBorderColor", colorState),
    borderRadius: t("milestoneBorderRadius"),
    borderWidth: t("milestoneBorderWidth")
  };
  var stepProps = {
    diameter: diameter,
    foregroundColor: stepColor
  };
  var iconTokens = props.type === "past" ? props.size === "large" ? _checkCircleFilled["default"] : _checkKnockout["default"] : null;
  return props.alert === "error" ? /*#__PURE__*/_react["default"].createElement("div", {
    className: stepStyles(stepProps)
  }, /*#__PURE__*/_react["default"].createElement(_icon["default"], {
    tokens: props.size === "large" ? props.type === "future" ? _error["default"] : _errorFilled["default"] : _errorKnockout["default"]
  })) : props.alert === "warning" ?
  /*#__PURE__*/
  // make this a triangle
  _react["default"].createElement("div", {
    className: stepStyles(stepProps)
  }, /*#__PURE__*/_react["default"].createElement(_icon["default"], {
    tokens: props.size === "large" ? props.type === "future" ? _alert["default"] : _alertFilled["default"] : _alertKnockout["default"]
  })) : /*#__PURE__*/_react["default"].createElement("div", {
    className: stepStyles(stepProps)
  }, iconTokens ? /*#__PURE__*/_react["default"].createElement(_icon["default"], {
    tokens: iconTokens
  }) : /*#__PURE__*/_react["default"].createElement(Circle, stepShapeProps));
}
Milestone.propTypes = process.env.NODE_ENV !== "production" ? {
  alert: _propTypes["default"].oneOf(["error", "warning", "none"]),
  neutral: _propTypes["default"].bool,
  // showIcon: PropTypes.bool,
  /**
   * Sets the size of the component using a preset.
   */
  size: _propTypes["default"].oneOf(["small", "large"]),
  type: _propTypes["default"].oneOf(["past", "present", "future"])
} : {};
var _default = Milestone;
exports["default"] = _default;